import * as React from "react";
import { cn } from "../lib/utils";

function normalizeTimeValue(value: string): string {
  const match = /^(\d{1,2}):(\d{1,2})/.exec(value.trim());
  if (!match) return "";
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (!Number.isInteger(hour) || !Number.isInteger(minute)) return "";
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return "";
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
}

export interface TimePickerProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  "aria-label"?: string;
}

export function TimePicker({
  value,
  onChange,
  disabled = false,
  className,
  "aria-label": ariaLabel = "時刻",
}: TimePickerProps) {
  return (
    <input
      type="time"
      value={normalizeTimeValue(value)}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        "flex h-9 rounded-md border-[0.5px] border-input bg-background px-3 py-1 text-sm tabular-nums shadow-sm",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
    />
  );
}
